import {
  IconAgreements,
  IconPeople,
  IconProducts,
  IconProjects,
  IconStores,
  IconUserManagement
} from 'assets'
import { StatsCards } from 'store'
import { DashboardCardProps } from './DashboardCard/DashboardCard.types'

export const dashboardCardPropsRepo: {
  [key in StatsCards]: DashboardCardProps
} = {
  [StatsCards.PROJECTS]: {
    icon: IconProjects,
    label: StatsCards.PROJECTS,
    valueSuffix: 'published',
    apiUrl: '/project/info'
  },
  [StatsCards.AGREEMENTS]: {
    icon: IconAgreements,
    label: StatsCards.AGREEMENTS,
    valueSuffix: 'active',
    apiUrl: '/agreement/info'
  },
  [StatsCards.PEOPLE]: {
    icon: IconPeople,
    label: StatsCards.PEOPLE,
    valueSuffix: 'people',
    apiUrl: '/person/info',
    totalIsMainValue: true
  },
  [StatsCards.PRODUCTS]: {
    icon: IconProducts,
    label: StatsCards.PRODUCTS,
    valueSuffix: 'active',
    apiUrl: '/product/info'
  },
  [StatsCards.STORES]: {
    icon: IconStores,
    label: StatsCards.STORES,
    valueSuffix: 'stores',
    apiUrl: '/brand/info',
    totalIsMainValue: true
  },
  [StatsCards.USERS]: {
    icon: IconUserManagement,
    label: StatsCards.USERS,
    valueSuffix: 'users',
    apiUrl: '/info',
    apiType: 'userApi',
    totalIsMainValue: true
  }
}
